// Mémoire d'un état d'affichage replié ou déplié, d'un écran à l'autre.
//
// Le stockage navigateur ne porte ici qu'un booléen par encart, JAMAIS de donnée de
// contenu : ce qui s'y perdrait ne coûte qu'un clic. C'est aussi pourquoi un échec de
// lecture ou d'écriture n'est pas fatal — navigation privée, quota atteint, stockage
// désactivé — mais il est DIT, jamais avalé.
//
// Écrit à part du contrôleur qui s'en sert : le back-office aura d'autres replis à
// mémoriser que les <details>, et une ligne qui porte des boutons ou un formulaire ne peut
// pas en être un — un <summary> n'a le droit de contenir ni l'un ni l'autre.

const STORAGE_PREFIX = "bo.disclosure."

// L'état mémorisé, ou `null` s'il n'a jamais été choisi. `null` compte : il laisse alors
// s'appliquer l'état rendu par le serveur, qui porte le défaut voulu pour cet encart.
// L'écraser par `false` reviendrait à replier ce que le serveur ouvre exprès.
export function readRememberedState(key) {
  try {
    const stored = window.localStorage.getItem(STORAGE_PREFIX + key)
    return stored === null ? null : stored === "true"
  } catch (error) {
    console.warn(`[remembered-state] mémoire illisible pour ${key}`, error)
    return null
  }
}

export function persistRememberedState(key, open) {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + key, String(open))
  } catch (error) {
    console.warn(`[remembered-state] état non mémorisé pour ${key}`, error)
  }
}
